// extracted by mini-css-extract-plugin
export default {"counterText":"counter_counterText__fOoo5","counterContent":"counter_counterContent__dnYoQ"};